import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import emailjs from "emailjs-com";
import contact from "../../images/contact.jpg";
import care6_ls2 from "../../images/care6_ls2.png";


const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_wholistic39",  // Replace with your EmailJS Service ID
        "template_wholistic39", // Replace with your EmailJS Template ID
        formData,
        "DeeyWGcO3WVXJ-uDJ"   // Replace with your EmailJS Public Key
      )
      .then(
        (response) => {
          console.log("SUCCESS!", response.status, response.text);
          alert("Email sent successfully!");
          setFormData({ name: "", email: "", message: "" });
        },
        (err) => {
          console.error("FAILED...", err);
          alert("Failed to send email. Please try again.");
        }
      );
  };

  useEffect(() => {
    const revealElements = document.querySelectorAll(".fade-in");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    revealElements.forEach((element) => observer.observe(element));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="contact-page">
      <Helmet>
        <title>Contact Us | Wholistic Nursing Care</title>
        <meta name="description" content="Get in touch with Wholistic Nursing Care for compassionate, personalized home healthcare services in Nairobi." />
        <meta name="keywords" content="contact nursing care Nairobi, home healthcare contacts, get in touch nursing services" />
        <link rel="canonical" href="https://wholistic.netlify.app/contact" />
      </Helmet>
      {/* Hero Section */}
      <section className="contact-hero">
        <img src={care6_ls2} alt="Contact Us" className="contact-hero-image" />
        <div className="contact-hero-text">
          <h1>Contact Us</h1>
          <p>We’d love to hear from you! Contact us today.</p>
        </div>
      </section>

      {/* Contact Form */}
      <section className="contact-form fade-in">
        <h2>Send Us a Message</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <textarea
            name="message"
            rows="5"
            placeholder="Your Message"
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>
          
          <button type="submit">Submit</button>
        </form>
      </section>

      {/* Contact Details */}
      <section className="contact-info fade-in">
        <div className="info-item">
          <h3>Email</h3>
          <p><a href="mailto:Info@wholistic.co.ke">Hello@wholistic.co.ke</a></p>
          <p><a href="mailto:Wholisticnursinhcareltd@gmail.com">Wholisticnursingcareltd@gmail.com</a></p>
          <p><a href="mailto:Hrrecruitment@wholistic.co.ke">Hrrecruitment@wholistic.co.ke</a></p>
        </div>

        <div className="info-item">
          <h3>Phone</h3>
          <p><a href="tel:+254707378979">+254707378979</a></p>
        </div>

        <div className="info-item">
          <h3>Location</h3>
          <p>Assi centre, school lane westlands</p>
        </div>
      </section>



      {/* Google Maps (Optional) */}
      <section className="contact-map fade-in">
        <h2>Visit Us</h2>
        {/* <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4336.781614271874!2d36.79372949678955!3d-1.2943182000000046!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f112adaf678ff%3A0xcbe7f2414ecde975!2sAPA%20ARCADE!5e1!3m2!1sen!2ske!4v1753350311347!5m2!1sen!2ske"
          width="100%"
          height="300"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Google Maps"
        ></iframe> */}

        <iframe 
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.8526617121!2d36.79767787522575!3d-1.2606125987273842!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f179c00b08df7%3A0x3ed0091703234590!2sAssi%20Centre!5e0!3m2!1sen!2ske!4v1780564065684!5m2!1sen!2ske" 
        width="100%"
          height="300" 
          style={{ border: 0 }}
        allowfullscreen="" 
        loading="lazy" 
        referrerpolicy="no-referrer-when-downgrade"
                  title="Google Maps"

        ></iframe>

      </section>
    </div>
  );
};

export default Contact;
